import React from 'react';
import View from "../View/View";
import {
  withFormControl,
  PuzzleButton,
  PuzzleToolbar
} from "puzzle";

import SubmissionAbstract from "../SubmissionAbstract";
import { config, tptTemplateConfig } from "./TemplateCreate.config";
import { Container } from "puzzle";
import { CREATE_STATE } from "../Types";

export type PROPS = {
  submissionMode: boolean
};

class TemplateCreate extends SubmissionAbstract<PROPS, CREATE_STATE> {
  static defaultProps = {
    submissionMode: 'TEMPLATE_CREATE'
  };

  /**
   * Cancel button handler, prompts warning window and redirects to previous pathname
   */
  onCancel = () => {
    this.dispatch('checkForChangesBeforeRedirect', '', { leaveAction: 'goBack' })
  }

  renderBody() {
    return (
      <Container vBox className={'tp-page tp-templateCreate-page'}>
        <Container
          alignItemsCenter
          className={'tp-page-header'}
          displayFlex
          justifyContentBetween
          wrap
        >
          <h2 className={'tp-page-title'}>
            {this.translate('newSubmission')}
          </h2>
          <PuzzleToolbar className={'tp-page-header-action-toolbar'}>
            <PuzzleButton
              fillMode={'outline'}
              onClick={this.onCancel}
            >
              {this.translate('cancel')}
            </PuzzleButton>
            <PuzzleButton
              onClick={this.triggerSubmissionAction.bind(this, 'saveSubmission', { staticFields: this.staticFields })}
              themeColor={'primary'}>
              {this.translate('save')}
            </PuzzleButton>
          </PuzzleToolbar>
        </Container>
        <View headerText={this.translate('newSubmission')} isTemplate={true} {...this.props} />
      </Container>
    )
  }
}

const Tpt = withFormControl(tptTemplateConfig, false)(TemplateCreate);
const Client = withFormControl(config, false)(TemplateCreate);

const TemplateCreateView = (props: { tptEnabled: boolean }): JSX.Element => {
  let mode = props.tptEnabled ? <Tpt tptEnabled={true} /> : <Client tptEnabled={false} />;
  return mode;
};

export default TemplateCreateView;